<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1">{{ data1['druidParamName'] }}<em v-if="data1['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data1['price'] }}</span></div>
        <div class="data2">{{ `${data2['druidParamName']}` }}<em v-if="data2['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data2['price'] }}</span>
        </div>
        <div class="data3">{{ `${data3['druidParamName']}` }}<em v-if="data3['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data3['price'] }}</span>
        </div>
        <div class="data4">{{ `${data4['druidParamName']}` }}<em v-if="data4['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data4['price'] }}</span>
        </div>
        <div class="data5">{{ `${data5['druidParamName']}` }}<em v-if="data5['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data5['price'] }}</span>
        </div>
        <div class="data6">{{ `${data6['druidParamName']}` }}<em v-if="data6['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data6['price'] }}</span>
        </div>
        <div class="data7">{{ `${data7['druidParamName']}` }}<em v-if="data7['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data7['price'] }}</span>
        </div>
        <div class="data8">{{ `${data8['druidParamName']}` }}<em v-if="data8['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data8['price'] }}</span>
        </div>
        <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
          {{ '+' + chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
        <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
          {{ '+' + chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
        <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
          {{ '+' + chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
        <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
          {{ '+' + chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
        <div class="differPrice5 redColor" v-if="chainPrice['differPrice5'] > 0">
          {{ '+' + chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5 greenColor" v-if="chainPrice['differPrice5'] < 0">{{ chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">—</div>
        <div class="differPrice6 redColor" v-if="chainPrice['differPrice6'] > 0">
          {{ '+' + chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6 greenColor" v-if="chainPrice['differPrice6'] < 0">{{ chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6" v-if="chainPrice['differPrice6'] === 0">—</div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write"
               :class="{'title-write-red' : true}">新闻资讯
          </div>
          <span class="title-more fr" @click="toTwoPage('/anhydride/twoPage/industry')">更多 ></span>
        </div>
        <div class="banner-right-content">
          <ul>
            <li v-for="(item, index) in industryList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/anhydride/industry', item.id, 2)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li>
          <ClassificationHeader :name="'苯酐及上游价格'" :flag="false" :unit="false"
                                :params="{title:'价格',typeList:['工业萘', '苯酐']}"
                                :url="'/anhydride/twoPage/price'"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="priceFlag = 'issue_anhydride_price_work'"
                style="width:186px;"
                @click="toTwoPage('/anhydride/twoPage/price', 'issue_anhydride_price_work')"
                :class="{'stockFlag':priceFlag === 'issue_anhydride_price_work'}">工业萘</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 'issue_anhydride_price_anhydride'"
                style="width:186px;"
                @click="toTwoPage('/anhydride/twoPage/price', 'issue_anhydride_price_anhydride')"
                :class="{'stockFlag':priceFlag === 'issue_anhydride_price_anhydride'}">苯酐</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === 'issue_anhydride_price_work'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in priceOneList" :key="index"
                 @click="goDetail('/anhydride/price', item.completeOriginalDate, 'issue_anhydride_price_work')">
              <i></i>
              <p>{{ item.date + '工业萘价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === 'issue_anhydride_price_anhydride'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in priceTwoList" :key="index"
                 @click="goDetail('/anhydride/price', item.completeOriginalDate, 'issue_anhydride_price_anhydride')">
              <i></i>
              <p>{{ item.date + '苯酐价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'苯酐装置动态'" :flag="true" :unit="false"
                                :url="'/anhydride/twoPage/device'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in deviceList" :key="index"
                 @click="goDetail('/anhydride/device', item.id)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <span class="fr" @click="toTwoPage('/anhydride/twoPage/report')"> >></span>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
            <div class="report-tabs">
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 1}"
                   @click="reportToPage('/anhydride/twoPage/report', 1)" @mouseover="changeReportFlag(1)">日报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 2}"
                   @click="reportToPage('/anhydride/twoPage/report', 2)" @mouseover="changeReportFlag(2)">周报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 3}"
                   @click="reportToPage('/anhydride/twoPage/report', 3)" @mouseover="changeReportFlag(3)">月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img style="width: 360px" src="../../assets/home/yanjiubaogao.png" alt="">
            <div v-if="reportFlag === 1">
              <div class="classification-content-div" v-for="(item, index) in reportList" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div class="classification-content-div" v-for="(item, index) in reportListWeek" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div class="classification-content-div" v-for="(item, index) in reportListMonth" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'苯酐进出口统计'" :flag="true" :unit="false"
                                :url="'/anhydride/twoPage/exit'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in exitList" :key="index"
                 @click="goDetail('/anhydride/exit', item.id)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'苯酐产量'" :flag="true" :unit="false" :url="'/anhydride/twoPage/yield'"
                                :params="{title:'苯酐产量'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in yieldList" :key="index"
                 @click="goDetail('/anhydride/yield', item.id)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li style="position:relative">
          <img src="../../assets/home/lirunwu.png" alt="">
          <span style="font-size: 24px;font-weight: 500;color: #fff;position: absolute;top: 20px;left: 20px;">苯酐利润</span>
          <span @click="toTwoPage('/anhydride/twoPage/profit')"
                style="right: 10px;position: absolute;top: 24px;color: #fff;cursor: pointer;"> >></span>
          <div class="classification-content" style="margin-top: -5px;">
            <div class="classification-content-div" style="height: 32px;line-height: 32px;" v-for="(item, index) in profitList" :key="index"
                 @click="goDetail('/anhydride/profit', item.completeOriginalDate)">
              <i></i>
              <p>{{ item.date + '苯酐利润' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'苯酐开工率'" :flag="true" :unit="false" :url="'/anhydride/twoPage/rate'"
                                :params="{title:'苯酐开工率'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in rateList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="goDetail('/anhydride/rate', item.completeOriginalDate)">{{ item.date + '苯酐开工率' }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'增塑剂价格'" :flag="true" :unit="false" :url="'/anhydride/twoPage/addPrice'"
                                :params="{title:'增塑剂价格'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in addPriceList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="goDetail('/anhydride/addPrice', item.completeOriginalDate)">{{ item.date + '增塑剂价格' }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'增塑剂开工率'" :flag="false" :unit="false"
                                :params="{title:'增塑剂开工率',typeList:['丁辛醇', 'DOP/DBP']}"
                                :url="'/anhydride/twoPage/addRate'"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="addRateFlag = '68'"
                style="width:186px;"
                @click="toTwoPage('/anhydride/twoPage/addRate', '68')"
                :class="{'stockFlag':addRateFlag === '68'}">丁辛醇</span>
          <span class="classification-tabs-two" @mouseover="addRateFlag = '93'"
                style="width:186px;"
                @click="toTwoPage('/anhydride/twoPage/addRate', '93')"
                :class="{'stockFlag':addRateFlag === '93'}">DOP/DBP</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="addRateFlag === '68'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in addRateOneList" :key="index"
                 @click="goDetail('/anhydride/addRate', item.id, '68')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="addRateFlag === '93'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in addRateTwoList" :key="index"
                 @click="goDetail('/anhydride/addRate', item.id, '93')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'增塑剂产量'" :flag="true" :unit="false" :url="'/anhydride/twoPage/addYield'"
                                :params="{title:'增塑剂产量'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in addYieldList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="goDetail('/anhydride/addYield', item.completeOriginalDate)">{{ item.date + '增塑剂产量' }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'增塑剂利润'" :flag="true" :unit="false" :url="'/anhydride/twoPage/addProfit'"
                                :params="{title:'增塑剂利润'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in addProfitList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="goDetail('/anhydride/addProfit', item.completeOriginalDate)">{{ item.date + '增塑剂利润' }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'萘系减水剂'" :flag="false" :unit="false"
                                :params="{title:'萘系减水剂',typeList:['价格', '进出口']}"
                                :url="'/anhydride/twoPage/cutWater'"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="cutFlag = 'issue_anhydride_water_price'"
                style="width:186px;"
                @click="toTwoPage('/anhydride/twoPage/cutWater', 'issue_anhydride_water_price')"
                :class="{'stockFlag':cutFlag === 'issue_anhydride_water_price'}">价格</span>
          <span class="classification-tabs-two" @mouseover="cutFlag = 'issue_anhydride_water_exit'"
                style="width:186px;"
                @click="toTwoPage('/anhydride/twoPage/cutWater', 'issue_anhydride_water_exit')"
                :class="{'stockFlag':cutFlag === 'issue_anhydride_water_exit'}">进出口</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="cutFlag === 'issue_anhydride_water_price'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in cutPriceList" :key="index"
                 @click="goDetail('/anhydride/cutWater', item.completeOriginalDate, 'issue_anhydride_water_price')">
              <i></i>
              <p>{{ item.date + '萘系减水剂价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="cutFlag === 'issue_anhydride_water_exit'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in cutExitList" :key="index"
                 @click="goDetail('/anhydride/cutWater', item.completeOriginalDate, 'issue_anhydride_water_exit')">
              <i></i>
              <p>{{ item.date + '萘系减水剂进出口' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'技术及标准'" :flag="true" :unit="false" :url="'/anhydride/twoPage/standard'" :neibu="true"
                                :params="{title:'技术及标准'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in standardList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="downloadStandard(item)">{{ item.fileTitle }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="1194px"
               :visible.sync="industrialFlag">
      <MaterialIndustrial @closeIndustrialCh="closeIndustrial" v-if="industrialFlag"></MaterialIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import {
  industryNoAuthList,
  zetarPriceNoAuthList,
  zetarReportNoAuthList,
  rateNoAuthList,
  downYieldNoAuthList,
  downExitNoAuthList,
  chainList,
} from '@/api/zetar'
import {
  industryDetail,
  reportDetail,
  standardDetail
} from '@/api/anhydride'
import ClassificationHeader from '@/components/common/ClassificationHeader'
import Expect from '@/components/common/expect'
import MaterialIndustrial from '@/components/bigChart/materialIndustrial'

export default {
  components: {
    ClassificationHeader,
    MaterialIndustrial,
    Expect,
  },
  data() {
    return {
      industryFlag: 2,
      industrialFlag: false,
      // 行业动态
      industryList: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      reportFlag: 2,
      // 价格指数
      priceFlag: 'issue_anhydride_price_work',
      priceOneList: [],
      priceTwoList: [],
      // 装置动态
      deviceList: [],
      // 进出口
      exitList: [],
      // 开工率
      rateList: [],
      // 产量
      yieldList: [],
      // 利润
      profitList: [],
      // 增塑剂价格
      addPriceList:[],
      // 增塑剂开工率
      addRateFlag:'68',
      addRateOneList:[],
      addRateTwoList:[],
      // 增塑剂产量
      addYieldList:[],
      // 增塑剂利润
      addProfitList:[],
      // 减水剂
      cutFlag:'issue_anhydride_water_price',
      cutPriceList:[],
      cutExitList:[],
      // 行业标准
      standardList: [],
      // 产业链
      chainTitle: '',
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      data8: {},
      chainPrice: {},
    }
  },
  created() {
    this.getHomeList()
  },
  methods: {
    /**
     * 获取首页信息
     */
    getHomeList() {
      // 产业链
      chainList({dictDataType: 'issue_anhydride_small_chain'}).then(res => {
        this.chainTitle = res.data['data1']['date'];
        this.data1 = res.data['data1'];
        this.data2 = res.data['data2'];
        this.data3 = res.data['data3'];
        this.data4 = res.data['data4'];
        this.data5 = res.data['data5'];
        this.data6 = res.data['data6'];
        this.data7 = res.data['data7'];
        this.data8 = res.data['data8'];
        this.chainPrice = res.data['price'];
      })
      // 行业动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 92}).then(res => {
        this.industryList = res.rows;
      })
      // 价格指数
      zetarPriceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_material_add_area_price'}).then(res => {
        this.priceOneList = res.rows;
      })
      zetarPriceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_anhydride_price_anhydride'}).then(res => {
        this.priceTwoList = res.rows;
      })
      // 装置动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 65}).then(res => {
        this.deviceList = res.rows;
      })
      // 研究报告
      zetarReportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 6, fileType: 1}).then(res => {
        this.reportList = res.rows;
      })
      zetarReportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 6, fileType: 2}).then(res => {
        this.reportListWeek = res.rows;
      })
      zetarReportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 6, fileType: 3}).then(res => {
        this.reportListMonth = res.rows;
      })
      // 进出口
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 66}).then(res => {
        this.exitList = res.rows;
      })
      // 产量
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 67}).then(res => {
        this.yieldList = res.rows;
      })
      // 利润
      zetarPriceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_anhydride_anhydride_profit'}).then(res => {
        this.profitList = res.rows;
      })
      // 开工率
      rateNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_anhydride_rate'}).then(res => {
        this.rateList = res.rows;
      })
      // 增塑剂价格
      zetarPriceNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_anhydride_plasticizer_price'}).then(res => {
        this.addPriceList = res.rows;
      })
      // 增塑剂开工率
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 68}).then(res => {
        this.addRateOneList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 93}).then(res => {
        this.addRateTwoList = res.rows;
      })
      // 增塑剂产量
      downYieldNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_anhydride_plasticizer_yield'}).then(res => {
        this.addYieldList = res.rows;
      })
      // 增塑剂利润
      zetarPriceNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_anhydride_plasticizer_profit'}).then(res => {
        this.addProfitList = res.rows;
      })
      // 萘系减水剂
      downExitNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_anhydride_water_price'}).then(res => {
        this.cutPriceList = res.rows;
      })
      downExitNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_anhydride_water_exit'}).then(res => {
        this.cutExitList = res.rows;
      })
      // 技术及标准
      zetarReportNoAuthList({pageNum: 1, pageSize: 8, sourceType: 6, fileType: 4}).then(res => {
        this.standardList = res.rows;
      })
    },
    /**
     * 前往行业报告二级
     */
    reportToPage(url, flag) {
      this.$router.push({path: url, query: {flag}})
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id']).then(() => {
        window.openUrl(item.newsContent)
      })
    },
    /**
     * 预览文件
     */
    downloadReport(row) {
      reportDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['苯酐', '研究报告', '正文'], row['id']);
      })
    },
    downloadStandard(row) {
      standardDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['苯酐', '技术及标准', '正文'], row['id']);
      })
    },
    /**
     * 切换tabs
     */
    changeFlag(flag) {
      this.industryFlag = flag;
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag, other) {
      this.$router.push({path: `${url}`, query: {id, flag, other}})
    },
  },
}
</script>

<style scoped lang="less">

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #D3131A;
    border-bottom: 2px solid #D3131A;
  }
}

.tabs-i-hover {
  color: #D3131A;
  border-bottom: 2px solid #D3131A;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/images/benganbanner.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      color: #B2F0E4;
      top: 31px;
      left: 248px;
      font-size: 12px;
    }

    .data1 {
      font-size: 10px;
      position: absolute;
      top: 234px;
      left: 32px;
      width: 96px;
      height: 50px;
    }

    .data2 {
      font-size: 10px;
      position: absolute;
      top: 131px;
      left: 203px;
      width: 95px;
      height: 50px;
    }

    .data3 {
      font-size: 10px;
      position: absolute;
      top: 236px;
      left: 203px;
      width: 95px;
      height: 50px;
    }

    .data4 {
      font-size: 10px;
      position: absolute;
      top: 101px;
      left: 364px;
      width: 95px;
      height: 50px;
    }

    .data5 {
      font-size: 10px;
      position: absolute;
      top: 206px;
      left: 364px;
      width: 95px;
      height: 50px;
    }

    .data6 {
      font-size: 10px;
      position: absolute;
      top: 301px;
      left: 364px;
      width: 95px;
      height: 50px;
    }

    .data7 {
      font-size: 10px;
      position: absolute;
      top: 108px;
      left: 527px;
      width: 95px;
      height: 50px;
    }

    .data8 {
      font-size: 10px;
      position: absolute;
      top: 202px;
      left: 527px;
      width: 95px;
      height: 50px;
    }

    .differPrice1 {
      position: absolute;
      top: 223px;
      left: 147px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice2 {
      position: absolute;
      top: 94px;
      left: 309px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice3 {
      position: absolute;
      top: 197px;
      left: 309px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice4 {
      position: absolute;
      top: 302px;
      left: 309px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice5 {
      position: absolute;
      top: 95px;
      left: 474px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice6 {
      position: absolute;
      top: 195px;
      left: 474px;
      width: 25px;
      height: 25px;
      text-align: center;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
      }

      .title-write-red {
        color: #fff;
        background: #D3131A;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;
      position: relative;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #D3131A;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #CCCCCC;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #D3131A;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          vertical-align: middle;
          margin-right: 9px;

        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 93px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        border-top: 2px solid #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-two:hover {
        border-top: 2px solid #D3131A;
        background: #D3131A;
        color: #fff;
      }

      .classification-tabs-three {
        width: 93px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        background: #D3131A;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9B857B;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {

            color: #D3131A;
            text-decoration: underline;
            //border-bottom: 1px solid #D3131A;
          }

          span {
            color: #777777;
            font-size: 12px;
          }

        }

        .price {
          height: 33px;
          line-height: 33px;
          padding: 0 10px;

          img {
            margin-right: 5px;
            width: 8px;
          }
        }

        .price:nth-child(2n+0) {
          background: #F2F2F2;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #DDDDDD;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n+0) {
      margin-right: 0;
    }
  }
}

.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #D3131A;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.bulletinWai {
  overflow: auto;
  height: 211px;
  border-bottom: 1px solid #ccc;
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
  }
}

.redColor {
  color: #FF6969;
}

.greenColor {
  color: #43E97B;
}
</style>
